// The project the phone's board and digest show, and the choice of it
// (Poulpe-881): the store's selected project, chosen as the desktop chooses
// it. This is the one place to change when the phone shows every project at
// once with project filters (Poulpe-893): the board and the digest read the
// project only through these.
import { useLocation, useNavigate } from 'react-router-dom'
import type { Project } from '../api/types'
import { useBoardState, useSelectedProject, useStore } from '../store/context'

/** The project the board and the digest show: the store's selected one. */
export function usePhoneProject(): Project | undefined {
  return useSelectedProject()
}

/**
 * The choice of project, when there are several: the store's selected one,
 * as the digest and the board follow it. At a project's own address
 * (`/p/<key>/…`), which selects its project, the choice goes to the chosen
 * project's address, which selects it.
 */
export function ProjectChoice({ id }: { id: string }) {
  const { projects } = useBoardState()
  const store = useStore()
  const project = usePhoneProject()
  const { pathname, search } = useLocation()
  const navigate = useNavigate()
  const all = [...projects.values()]
  if (all.length < 2) return null
  const choose = (chosen: string) => {
    const own = /^\/p\/[^/]+(\/.*)$/.exec(pathname)
    const key = projects.get(chosen)?.key
    if (own && key) navigate(`/p/${encodeURIComponent(key)}${own[1]}${search}`, { replace: true })
    else store.selectProject(chosen)
  }
  return (
    <div className="form-field">
      <label htmlFor={id}>Project</label>
      <select id={id} className="input m-target" value={project?.id ?? ''} onChange={(event) => choose(event.target.value)}>
        {all.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
      </select>
    </div>
  )
}

